import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Slide,
    Stack,
    Typography,
    TextField,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React, { forwardRef, useState } from 'react';
import AquantCancelIcon from '../resources/images/aq-cancel.svg';
import { useTranslation } from 'react-i18next';
import SiDialog from '../components/SiDialog';
import Backend from '../backend/Backend';
import { useOktaAuth } from '@okta/okta-react';
import './AddNewCustomerDialog.scss';
import { ITenantData } from '../common/types';

type Props = {
    open: boolean;
    onClose: () => void;
    addNewCustomer: (newCustomer: ITenantData) => void;
    progress: Function;
};

const Transition = forwardRef(
    (
        props: TransitionProps & {
            children: React.ReactElement;
        },
        ref: React.Ref<unknown>,
    ) => <Slide direction="up" ref={ref} {...props} />,
);

const AddNewCustomerDialog = (props: Props) => {
    const { open, onClose, addNewCustomer } = props;
    const [companyName, setCompanyName] = useState('');
    const { oktaAuth } = useOktaAuth();
    const [errorMsg, setErrorMsg] = useState<string>('');

    const handleOnClose = () => {
        setErrorMsg('');
        setCompanyName('');
        onClose();
    };

    const handleOnCreateCustomer = async () => {
        props.progress(true);
        const res = await Backend.createTenant(companyName, oktaAuth);

        if (res.status !== 200) {setErrorMsg(res.data.detail);}
        else {
            addNewCustomer(res.data);
            handleOnClose();
        }

        props.progress(false);
    };

    return (
        <SiDialog open={open} onClose={handleOnClose} TransitionComponent={Transition}>
            <DialogTitle>
                <Stack className="DialogTitle">
                    <Typography className="DialogTitleText">Create New Customer</Typography>
                    <img src={AquantCancelIcon} onClick={handleOnClose} alt="cancel icon" className="CancelIcon" />
                </Stack>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Typography className="DialogContentTitle">Company Name</Typography>
                <TextField
                    error={errorMsg !== ''}
                    required
                    id="outlined-required"
                    sx={{ width: 350 }}
                    onChange={(e) => {
                        setCompanyName(e.target.value);
                    }}
                    value={companyName}
                    helperText={errorMsg}
                    FormHelperTextProps={{ className: 'HelperText' }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleOnClose} disableRipple className="DialogActionBtn">
                    Cancel
                </Button>
                <Button
                    onClick={handleOnCreateCustomer}
                    variant="contained"
                    disableRipple
                    disabled={companyName === '' || !companyName.replace(/\s/g, '').length}
                    className="DialogActionBtn DialogActionBtnContained"
                >
                    Create Customer
                </Button>
            </DialogActions>
        </SiDialog>
    );
};

export default AddNewCustomerDialog;
